import {
  createDocument,
  getDocuments,
  updateDocument,
} from '../services/documents';
import { TIMEZONE_GMT } from '../services/request';

const getUser = () => JSON.parse(localStorage.getItem('auth-user') as any);

export const getVouchers = async (
  page: number = 1,
  pageSize: number = 10,
  code: string = '',
  title: string = '',
  description: string = '',
  kind: string = '',
  status: string = '',
) => {
  const data = getDocuments(
    `vouchers?page=${page}&size=${pageSize}&code=${code}&title=${title}&description=${description}&kind=${kind}&status=${status}&tenantPk=${
      getUser().tenant_pk
    }&timeZone=${TIMEZONE_GMT}`,
  );

  return data;
};

export const createVouchers = async (vouchers) => {
  const data = await createDocument(vouchers, 'vouchers');

  return data;
};

export const updateVouchers = async (id, payload) => {
  const data = await updateDocument(id, payload, 'vouchers');

  return data;
};

export const getVoucherDetail = async (voucherPk: string) => {
  const data = getDocuments(`vouchers/${voucherPk}?&timeZone=${TIMEZONE_GMT}`);

  return data;
};

export const getVoucherHistory = async (voucherPk: string) => {
  const data = getDocuments(`vouchers/${voucherPk}/history`);

  return data;
};

export const getVoucherCodeInUse = async (code: string) => {
  const data = getDocuments(
    `vouchers/code-in-use?code=${encodeURIComponent(code)}`,
  );

  return data;
};
